export default function useMouseEvents(
  mouseDownHandler: Function,
  mouseMoveHandler: Function,
  mouseUpHandler: Function
) {
  return function mouseEventsHandler(event: MouseEvent) {
    let positions = mouseDownHandler(event);

    function onMouseMove(event: MouseEvent) {
      positions = mouseMoveHandler(event, positions) || positions;
    }

    window.addEventListener("mousemove", onMouseMove);

    window.addEventListener(
      "mouseup",
      event => {
        window.removeEventListener("mousemove", onMouseMove);
        mouseUpHandler && mouseUpHandler(event, positions);
      },
      { once: true }
    );
  };
}
